import { render, staticRenderFns } from "./ModalSMSWithAGift.vue?vue&type=template&id=0ce45f93&scoped=true&"
import script from "./ModalSMSWithAGift.vue?vue&type=script&lang=js&"
export * from "./ModalSMSWithAGift.vue?vue&type=script&lang=js&"
import style0 from "./ModalSMSWithAGift.vue?vue&type=style&index=0&id=0ce45f93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce45f93",
  null
  
)

export default component.exports